import { View } from "@react-pdf/renderer";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";
import {
  ResumePDFDescriptionWithWhiteFont,
  TemplateNineteenPDFSection,
  TemplateNineteenSection,
  ResumePDFDescription,
} from "./common";

export const Skills = ({
  heading,
  skills,
  themeColor,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateNineteenSection themeColor={themeColor} heading={heading}>
      <View  style={{ ...styles.flexCol }} wrap={false}>
        <ResumePDFDescription  items={descriptions} />
      </View>
    </TemplateNineteenSection>
  );
};
